<mat-card class="system-card">
	<mat-card-header>
		<mat-card-title>Podsumowanie</mat-card-title>
	</mat-card-header>
	<mat-card-content>
		<div class="summary-breakdown">
			<div class="breakdown-row">
				<span class="breakdown-label">Nawigator</span>
				<span class="breakdown-amount amount-positive">
					+ {{ state.nawigatorTotalPln() | priceCurrency: 'PLN' }}
				</span>
			</div>
			<div class="breakdown-row">
				<span class="breakdown-label">
					Dieta (Enova − Gratyfikant)
					<small class="breakdown-sublabel">
						{{ state.enovaTotal() ?? 0 | priceCurrency: 'PLN' }} −
						{{ state.gratyfikantTotal() ?? 0 | priceCurrency: 'PLN' }}
					</small>
				</span>
				<span
					class="breakdown-amount"
					[class.amount-negative]="state.effectiveDietaPln() >= 0"
					[class.amount-positive]="state.effectiveDietaPln() < 0"
				>
					{{ state.effectiveDietaPln() >= 0 ? '−' : '+' }}
					{{
						(state.effectiveDietaPln() < 0 ? -state.effectiveDietaPln() : state.effectiveDietaPln())
							| priceCurrency: 'PLN'
					}}
				</span>
			</div>
			<div class="breakdown-row">
				<span class="breakdown-label">Gratyfikant</span>
				<span class="breakdown-amount amount-negative">
					− {{ state.gratyfikantTotal() ?? 0 | priceCurrency: 'PLN' }}
				</span>
			</div>
			<div class="breakdown-row">
				<span class="breakdown-label">Dodatki / potrącenia</span>
				<span class="breakdown-amounts">
					<span
						class="breakdown-amount"
						[class.amount-positive]="state.settlementNetPln() >= 0"
						[class.amount-negative]="state.settlementNetPln() < 0"
					>
						{{ state.settlementNetPln() >= 0 ? '+' : '−' }}
						{{
							(state.settlementNetPln() < 0 ? -state.settlementNetPln() : state.settlementNetPln())
								| priceCurrency: 'PLN'
						}}
					</span>
					@if (state.settlementNetEur() !== 0) {
						<span
							class="breakdown-amount breakdown-amount-secondary"
							[class.amount-positive]="state.settlementNetEur() >= 0"
							[class.amount-negative]="state.settlementNetEur() < 0"
						>
							{{ state.settlementNetEur() >= 0 ? '+' : '−' }}
							{{
								(state.settlementNetEur() < 0 ? -state.settlementNetEur() : state.settlementNetEur())
									| priceCurrency: 'EUR'
							}}
						</span>
					}
				</span>
			</div>
			<div class="breakdown-row">
				<span class="breakdown-label">Kasa</span>
				<span class="breakdown-amounts">
					<span
						class="breakdown-amount"
						[class.amount-positive]="state.ledgerPendingTotals().pln < 0"
						[class.amount-negative]="state.ledgerPendingTotals().pln >= 0"
					>
						{{ state.ledgerPendingTotals().pln >= 0 ? '−' : '+' }}
						{{
							(state.ledgerPendingTotals().pln < 0
								? -state.ledgerPendingTotals().pln
								: state.ledgerPendingTotals().pln
							) | priceCurrency: 'PLN'
						}}
					</span>
					@if (state.ledgerPendingTotals().eur !== 0) {
						<span
							class="breakdown-amount breakdown-amount-secondary"
							[class.amount-positive]="state.ledgerPendingTotals().eur < 0"
							[class.amount-negative]="state.ledgerPendingTotals().eur >= 0"
						>
							{{ state.ledgerPendingTotals().eur >= 0 ? '−' : '+' }}
							{{
								(state.ledgerPendingTotals().eur < 0
									? -state.ledgerPendingTotals().eur
									: state.ledgerPendingTotals().eur
								) | priceCurrency: 'EUR'
							}}
						</span>
					}
				</span>
			</div>
		</div>
		<div class="summary-row">
			<mat-form-field appearance="outline" class="display-only">
				<mat-label>Suma miesięczna PLN</mat-label>
				<input matInput [value]="state.sumAllPln() | priceFormat" readonly tabindex="-1" />
			</mat-form-field>
			<mat-form-field appearance="outline" class="display-only">
				<mat-label>Suma miesięczna EUR</mat-label>
				<input matInput [value]="state.sumAllEur() | priceFormat" readonly tabindex="-1" />
			</mat-form-field>
		</div>
		<div class="summary-row">
			<mat-form-field appearance="outline" [class.display-only]="state.isSettled()">
				<mat-label>Przelew PLN</mat-label>
				<input
					matInput
					type="text"
					inputmode="decimal"
					[value]="state.effectiveTransferPln() | priceFormat"
					[readonly]="state.isSettled()"
					[tabindex]="state.isSettled() ? -1 : 0"
					(focus)="$any($event.target).select()"
					(blur)="onTransferPlnBlur($any($event.target))"
				/>
			</mat-form-field>
			<mat-form-field appearance="outline" [class.display-only]="state.isSettled()">
				<mat-label>Gotówka PLN</mat-label>
				<input
					matInput
					type="text"
					inputmode="decimal"
					[value]="state.effectiveCashPln() | priceFormat"
					[readonly]="state.isSettled()"
					[tabindex]="state.isSettled() ? -1 : 0"
					(focus)="$any($event.target).select()"
					(blur)="onCashPlnBlur($any($event.target))"
				/>
			</mat-form-field>
			<mat-form-field appearance="outline" [class.display-only]="state.isSettled()">
				<mat-label>Gotówka EUR</mat-label>
				<input
					matInput
					type="text"
					inputmode="decimal"
					[value]="state.effectiveCashEur() | priceFormat"
					[readonly]="state.isSettled()"
					[tabindex]="state.isSettled() ? -1 : 0"
					(focus)="$any($event.target).select()"
					(blur)="onCashEurBlur($any($event.target))"
				/>
			</mat-form-field>
			@if (state.plnSplitMismatch() || state.eurSplitMismatch()) {
				<div class="split-status split-status-error" role="alert">
					<i class="bi bi-exclamation-triangle-fill"></i>
					<div class="split-status-body">
						<strong>Wartości nie są prawidłowe</strong>
						@if (state.plnSplitMismatch()) {
							<span>Przelew PLN + Gotówka PLN ≠ Suma miesięczna PLN</span>
						}
						@if (state.eurSplitMismatch()) {
							<span>Gotówka EUR ≠ Suma miesięczna EUR</span>
						}
					</div>
				</div>
			} @else {
				<div class="split-status split-status-success" role="status">
					<i class="bi bi-check-circle-fill"></i>
					<div class="split-status-body">
						<strong>Wartości są prawidłowe</strong>
						<span>Przelew + Gotówka = Suma miesięczna</span>
					</div>
				</div>
			}
		</div>

		<div class="summary-notes">
			<mat-form-field appearance="outline" class="summary-notes-field">
				<mat-label>Uwagi do rozliczenia</mat-label>
				<textarea
					matInput
					rows="3"
					[value]="state.settlementNotes()"
					[readonly]="state.isSettled()"
					(input)="state.settlementNotes.set($any($event.target).value)"
					(blur)="state.saveNotes()"
				></textarea>
			</mat-form-field>
			<mat-form-field appearance="outline" class="summary-notes-field">
				<mat-label>Uwagi do wypłaty</mat-label>
				<textarea
					matInput
					rows="3"
					[value]="state.paymentNotes()"
					[readonly]="state.isSettled()"
					(input)="state.paymentNotes.set($any($event.target).value)"
					(blur)="state.saveNotes()"
				></textarea>
			</mat-form-field>
		</div>

		@if (state.overridesError()) {
			<div class="alert alert-danger d-flex align-items-center mb-2" role="alert">
				<i class="bi bi-exclamation-triangle-fill me-2"></i>
				<div><strong>Błąd zapisu korekty:</strong> {{ state.overridesError() }}</div>
			</div>
		}
		@if (state.notesError()) {
			<div class="alert alert-danger d-flex align-items-center mb-2" role="alert">
				<i class="bi bi-exclamation-triangle-fill me-2"></i>
				<div><strong>Błąd zapisu uwag:</strong> {{ state.notesError() }}</div>
			</div>
		}
		@if (state.settleError()) {
			<div class="alert alert-danger d-flex align-items-center mb-2" role="alert">
				<i class="bi bi-exclamation-triangle-fill me-2"></i>
				<div><strong>Błąd rozliczenia:</strong> {{ state.settleError() }}</div>
			</div>
		}

		<div class="settle-bar">
			<div class="settle-status">
				@if (state.isSettled()) {
					<span class="settle-badge">
						<i class="bi bi-check-circle-fill me-1"></i>
						Rozliczono {{ state.settledAt() | date: 'd MMM yyyy, HH:mm' }}
						@if (state.settledBy()) {
							· {{ state.settledBy() }}
						}
					</span>
					<button
						mat-button
						color="warn"
						type="button"
						class="settle-undo"
						[disabled]="state.settleLoading()"
						(click)="state.unsettleMonth()"
					>
						Cofnij rozliczenie
					</button>
				} @else if (state.notesSaving()) {
					<span class="notes-saving"
						><mat-spinner diameter="14" class="me-1 d-inline-block"></mat-spinner> Zapisywanie uwag…</span
					>
				}
			</div>
			@if (!state.isSettled()) {
				<button
					mat-raised-button
					color="primary"
					type="button"
					[disabled]="state.settleLoading()"
					(click)="state.settleMonth()"
				>
					@if (state.settleLoading()) {
						<mat-spinner diameter="18" class="me-2 d-inline-block"></mat-spinner>
					}
					Rozlicz miesiąc ({{ state.selectedMonthLabel() }})
				</button>
			}
		</div>
	</mat-card-content>
</mat-card>
